import { createFileRoute, isNotFound } from '@tanstack/react-router';
import { preloadImageOnClient, heroImageSize } from '@worldcoo/ui/lib/utils';
import { portalAuthorOptions, portalMetadataOptions, usePortalMetadataQuery } from '@/lib/queries';
import { getLegalContentFn } from '@/lib/server-functions';
import { Footer } from './-components/footer';
import { Header } from './-components/header';
import { Suspense } from 'react';
import { Seo } from './-components/seo';
import { generateImageSrc, getLogoImageSize } from '@/lib/shared';

export const Route = createFileRoute('/$portalId/privacy')({
	loader: ({ context }) => {
		context.queryClient
			.ensureQueryData(portalAuthorOptions({ locale: context.locale, portalId: context.portalId }))
			.then((data) => {
				if ('notFound' in data) return;
				if (!data.logo?.location) return;
				preloadImageOnClient(
					generateImageSrc(data.logo.location, {
						height: getLogoImageSize(context.portalId).height,
						width: (data.logo.width / data.logo.height) * getLogoImageSize(context.portalId).height,
					}),
				);
			});

		context.queryClient
			.ensureQueryData(portalMetadataOptions({ locale: context.locale, portalId: context.portalId }))
			.then((data) => {
				if ('notFound' in data) return;
				if (!data.media?.location) return;
				preloadImageOnClient(generateImageSrc(data.media.location, heroImageSize));
			});

		return getLegalContentFn({ data: { type: 'privacy-policy', locale: context.locale } });
	},
	component: Component,
});

function Component() {
	const html = Route.useLoaderData();
	const metadata = usePortalMetadataQuery();
	if (isNotFound(metadata)) return null;

	return (
		<main className="w-full">
			<Header />
			<Suspense>
				<SuspensedHead />
			</Suspense>

			<article className="unreset-tailwind mx-auto max-w-4xl p-8" dangerouslySetInnerHTML={{ __html: html }} />

			<Footer />
		</main>
	);
}

function SuspensedHead() {
	const metadata = usePortalMetadataQuery();
	if (isNotFound(metadata)) return null;

	return (
		<Seo
			title={metadata.texts.title}
			description={metadata.texts.presentation}
			image={metadata.media?.location ? generateImageSrc(metadata.media.location) : undefined}
		/>
	);
}
